<template>
    <div class="side-page" v-if="visible">
      <div class="side-page-content">
        <h2>Edit Asset</h2>
  
        <div class="form-group">
          <label for="deviceName">Device Name:</label>
          <input id="deviceName" v-model="deviceName" placeholder="Enter device name" />
        </div>
  
        <div class="form-group">
          <label for="deviceType">Device Type:</label>
          <input id="deviceType" v-model="deviceType" placeholder="Enter device type" />
        </div>
  
        <div class="form-group">
          <label for="building">Building:</label>
          <input id="building" v-model="building" placeholder="Enter building" />
        </div>
  
        <div class="form-group">
          <label for="floor">Floor:</label>
          <input id="floor" v-model="floor" placeholder="Enter floor" />
        </div>
  
        <div class="form-group">
          <label for="lastScannedZone">Last Scanned Zone:</label>
          <input id="lastScannedZone" v-model="lastScannedZone" placeholder="Enter last scanned zone" />
        </div>
  
        <div class="form-group">
          <label for="assignedZone">Assigned Zone:</label>
          <input id="assignedZone" v-model="assignedZone" placeholder="Enter assigned zone" />
        </div>
  
        <div class="form-group">
          <label for="imageUpload">Upload Image:</label>
          <input type="file" id="imageUpload" @change="handleImageUpload" />
        </div>
  
        <div class="button-group">
          <button @click="save">Save</button>
          <button @click="close">Cancel</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      visible: {
        type: Boolean,
        required: true,
      },
      asset: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        deviceName: this.asset.devicename || '',
        deviceType: this.asset.devicetype || '',
        building: this.asset.building || '',
        floor: this.asset.floor || '',
        lastScannedZone: this.asset.taglocation || '',
        assignedZone: this.asset.assignedzone || '',
        imageFile: null, // 업로드된 이미지 파일
      };
    },
    methods: {
      handleImageUpload(event) {
        console.log('이미지 업로드 이벤트:', event);
        this.imageFile = event.target.files[0];
        console.log('선택된 이미지:', this.imageFile);
      },
      save() {
        console.log('save 메소드 호출');
        const formData = new FormData();
        formData.append('tag_mac', this.asset.tag_mac);
        formData.append('devicename', this.deviceName);
        formData.append('devicetype', this.deviceType);
        formData.append('building', this.building);
        formData.append('floor', this.floor);
        formData.append('taglocation', this.lastScannedZone);
        formData.append('assignedzone', this.assignedZone);
  
        if (this.imageFile) {
          console.log('이미지 파일 추가:', this.imageFile.name);
          formData.append('image', this.imageFile);
        }
  
        // FormData 내용 확인
        for (let pair of formData.entries()) {
          console.log(pair[0] + ': ' + pair[1]);
        }
  
        this.$emit('save', formData);
      },
      close() {
        this.$emit('close');
      },
    },
  };
  </script>
  
  <style scoped>
  .side-page {
    position: fixed;
    top: 0;
    right: 0;
    width: 400px; /* 너비 조정 */
    height: 100%;
    background-color: white;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
    padding: 20px;
    z-index: 1000;
    /* overflow-y: auto; 스크롤 가능 */
    font-family: Arial, sans-serif; /* 폰트 설정 */
  }
  
  h2 {
    margin-bottom: 20px; /* 제목과 입력 폼 사이의 간격 */
  }
  
  .form-group {
    margin-bottom: 15px;
    margin-right: 20px;
  }
  
  label {
    font-weight: bold; /* 레이블 볼드체 */
    display: block; /* 블록 요소로 설정 */
    margin-bottom: 5px; /* 레이블과 입력 필드 간격 */
  }
  
  input {
    width: 100%; /* 전체 너비 */
    padding: 10px; /* 패딩 추가 */
    border: 1px solid #ccc; /* 테두리 색상 */
    border-radius: 4px; /* 테두리 둥글게 */
  }
  
  .button-group {
    margin-top: 20px; /* 버튼 그룹 상단 간격 */
    display: flex;
    justify-content: space-between; /* 버튼 간격 조정 */
  }
  
  button {
    width: 48%; /* 버튼 너비 */
    padding: 10px; /* 패딩 추가 */
    border: none; /* 기본 테두리 제거 */
    border-radius: 4px; /* 버튼 테두리 둥글게 */
    background-color: #4CAF50; /* 버튼 배경색 */
    color: white; /* 버튼 글자색 */
    cursor: pointer; /* 포인터 커서 */
  }
  
  button:hover {
    background-color: #45a049; /* 호버 시 색상 변경 */
  }
  </style>
  